require('angular').module('wowApp.common')
    .service('SavedListsService', require('./saved-lists.service'));



// WEBPACK FOOTER //
// ./src/common/savedlists/index.js